import { Card } from '../../components/layout/Card';

/**
 * Stand-in body for a nav screen until its phase builds it. Deliberately
 * plain: no fixture numbers — a placeholder that looks like data gets
 * mistaken for data.
 */
export function PlaceholderScreen() {
  return (
    <Card>
      <p className="m-0 text-sm text-muted">Nothing here yet.</p>
    </Card>
  );
}
